import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PrestamosListComponent } from './prestamos-list.component';
import { PrestamosService } from './prestamos.service';

@Component({
    selector: 'convfact-prestamosdelete',
    templateUrl: './prestamos-dialog-delete.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<PrestamosListComponent>,
    public prestamosService: PrestamosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.prestamosService.delete(this.uid)
      .then(res => {
        this.response_message = "El préstamo se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar el préstamo";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
